var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("审批配置")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("p", { staticClass: "header" }, [_vm._v("审批配置")]),
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.formInline },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审批人称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入审批人称" },
                    model: {
                      value: _vm.formInline.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInline, "name", $$v)
                      },
                      expression: "formInline.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSearch } },
                    [_vm._v("搜索")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.approvalType()
                        },
                      },
                    },
                    [_vm._v("添加")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "manage" }, [
        _c(
          "div",
          { staticClass: "table" },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.tableData.list } },
              [
                _c("el-table-column", {
                  attrs: { type: "index", label: "序号", width: "100" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "typeName", label: "类型" },
                }),
                _c("el-table-column", {
                  attrs: { label: "审配人", prop: "userNames" },
                }),
                _c("el-table-column", {
                  attrs: { label: "更新时间", prop: "createdTime" },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "optain" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "添加/修改",
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _vm.parArray.indexOf("sptj") != -1
                                    ? _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              _vm.Visible = true
                                              _vm.viewPermissions(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(" 添加/修改 ")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm.tableData.totalNum >= 8
              ? _c("div", { staticClass: "page" }, [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page": _vm.currentPage1,
                          "page-size": 1,
                          layout: "total, prev, pager, next",
                          "prev-text": "上一页",
                          "next-text": "下一页",
                          total: _vm.tableData.totalPage,
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange,
                          "update:currentPage": function ($event) {
                            _vm.currentPage1 = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.currentPage1 = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: _vm.title,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": _vm.formLabelWidth,
                    label: "权限名称",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入权限名称" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": _vm.formLabelWidth,
                    label: "权限描述",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", placeholder: "请输入权限描述" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { "label-width": _vm.formLabelWidth, label: "状态" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "A" },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [_vm._v("开启")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "S" },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [_vm._v("禁用")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnloading },
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                      _vm.updateBattery()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.Visible,
            "append-to-body": true,
            title: _vm.title,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.Visible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tree" },
            [
              _c("el-input", {
                staticStyle: { margin: "0 0px 20px" },
                attrs: { placeholder: "输入关键字进行搜索" },
                model: {
                  value: _vm.filterText,
                  callback: function ($$v) {
                    _vm.filterText = $$v
                  },
                  expression: "filterText",
                },
              }),
              _c("el-tree", {
                ref: "tree",
                staticClass: "el-menu-vertical-demo",
                attrs: {
                  data: _vm.tree,
                  props: _vm.defaultProps,
                  "highlight-current": true,
                  "default-expand-all": true,
                  "filter-node-method": _vm.filterNode,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table1" },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tablePerson.list,
                    "row-key": _vm.getRowKey,
                  },
                  on: {
                    select: _vm.selectEvent,
                    "select-all": _vm.handleAllChange,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      "reserve-selection": true,
                      width: "50",
                      align: "center",
                    },
                    model: {
                      value: _vm.multipleSelection,
                      callback: function ($$v) {
                        _vm.multipleSelection = $$v
                      },
                      expression: "multipleSelection",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "序号", type: "index", width: "100" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "姓名" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c(
                              "p",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.toInfo(props.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(props.row.reallyName))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "联系电话", prop: "phoneNumber" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "所在部门" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c("span", [_vm._v(_vm._s(props.row.orgName))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "职位", prop: "positionName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "员工状态", prop: "statusName" },
                  }),
                ],
                1
              ),
              _vm.tablePerson.totalNum >= 5
                ? _c("div", { staticClass: "page" }, [
                    _c(
                      "div",
                      { staticClass: "block" },
                      [
                        _c("span", { staticClass: "demonstration" }, [
                          _vm._v(
                            "共" + _vm._s(_vm.tablePerson.totalPage) + "页"
                          ),
                        ]),
                        _c("span", { staticClass: "demonstration" }, [
                          _vm._v(
                            "总共" + _vm._s(_vm.tablePerson.totalNum) + "条"
                          ),
                        ]),
                        _c("el-pagination", {
                          attrs: {
                            background: "",
                            "current-page": _vm.page1,
                            "page-size": 1,
                            layout: "prev, pager, next",
                            "prev-text": "上一页",
                            "next-text": "下一页",
                            total: _vm.tablePerson.totalPage,
                          },
                          on: {
                            "current-change": _vm.handleCurrent,
                            "update:currentPage": function ($event) {
                              _vm.page1 = $event
                            },
                            "update:current-page": function ($event) {
                              _vm.page1 = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "checked" }, [
            _c("p", [_vm._v("选中员工")]),
            _c(
              "ul",
              { staticClass: "employee" },
              _vm._l(_vm.multipleSelection, function (items, index) {
                return _c(
                  "li",
                  { key: items.id },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(items.orgName) + "-" + _vm._s(items.reallyName)
                      ),
                    ]),
                    _c("icon", {
                      staticClass: "el-icon-circle-close",
                      staticStyle: {
                        position: "absolute",
                        right: "-1px",
                        top: "-1px",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteOne(items)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.selectId = []
                      _vm.Visible = false
                      _vm.toggleSelection()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnloading },
                  on: {
                    click: function ($event) {
                      _vm.Visible = false
                      _vm.submission()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "box1" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.addCont,
                "append-to-body": "",
                title: "添加审批配置",
                width: "40%",
                height: "300px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.addCont = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "approveStyle" },
                [
                  _c("span", [_vm._v("类型")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择审批类型",
                        clearable: "",
                      },
                      model: {
                        value: _vm.approvalCont.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.approvalCont, "name", $$v)
                        },
                        expression: "approvalCont.name",
                      },
                    },
                    _vm._l(_vm.approval, function (items) {
                      return _c("el-option", {
                        key: items.dictId,
                        attrs: { label: items.dictName, value: items.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.updateAdd },
                    },
                    [_vm._v("确 定")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          _vm.addCont = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }